<template>
    <div>
        ServiceProvider
    </div>
</template>
<script>
export default {
    name: "ServiceProviderHome"
}
</script>